import { defer } from "./script";

export function autoScrollInput() {
  $("body").on("focus", "[autoscroll]", function (e) {
    const parent = $(this).attr("scrollparent") || "html, body";
    let padding = $(this).attr("scrollpadding");
    padding = padding === "" || padding === undefined ? 8 : +padding;
    let scrolling = false;
    setTimeout(() => {
      defer(() => !scrolling, () => {
        const position = $(this).offset().top + $(this).outerHeight() - $(window).outerHeight() + padding;
        if ($(this).is(":focus") && $(parent).scrollTop() < position) {
          scrolling = true;
          $(parent).animate({
            scrollTop: position,
          }, (position - $(parent).scrollTop()) * 4, function () { scrolling = false; });
        }
      });
    }, 600);
    setTimeout(() => {
      defer(() => !scrolling, () => {
        const position = $(this).offset().top + $(this).outerHeight() - $(window).outerHeight() + padding;
        if ($(this).is(":focus") && $(parent).scrollTop() < position) {
          scrolling = true;
          $(parent).animate({
            scrollTop: position,
          }, (position - $(parent).scrollTop()) * 4, function () { scrolling = false; });
        }
      });
    }, 1200);
  });
}